import { useContext } from 'react';
import {
	MarketStateFilterInputContext,
	MarketStateFilterInputTools,
} from '@app/site/secured/rateshopper/rates/provider/MarketStateFilterInputProvider';

export const useMarketStateFilterInputTools = (): MarketStateFilterInputTools => {
	return useContext(MarketStateFilterInputContext)!;
};